let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4aHh3")).then(() => parcelRequire('h0XaB'));